export default __webpack_public_path__ + "static/media/drone13.716f97c4.jpg";